import React, { useState } from "react";
import { UseFormRegister, UseFormWatch } from "react-hook-form";
import { RentReceiptForm } from ".";
import { REGEX } from "../../../../constants/regex";

const RentReceiptPersonalDetails = ({
  register,
  watch,
  errors,
}: {
  register: UseFormRegister<RentReceiptForm>;
  watch: UseFormWatch<RentReceiptForm>;
  errors?: any;
}) => {
  const formValues = watch();

  return (
    <div className="mt-[40px] px-[24px]">
      <div className="flex justify-between gap-4">
        <InputField
          value={formValues.first_name}
          errors={errors?.first_name?.message}
          label="First Name"
          register={{
            ...register("first_name", { required: "First name is required." }),
          }}
        />
        <InputField
          value={formValues.last_name}
          label="Last Name"
          errors={errors?.last_name?.message}
          register={{
            ...register("last_name", { required: "Last name is required." }),
          }}
        />
      </div>
      <div className="mt-4">
        <InputField
          value={formValues.monthlyRent?.toString() || ""}
          errors={errors?.monthlyRent?.message}
          label="Monthly Rent"
          register={{
            ...register("monthlyRent", {
              required: "Monthly rent is required.",
              min: { value: 10, message: "Please enter a valid monthly rent." },
            }),
          }}
        />
      </div>
      <div className="mt-4">
        <InputField
          value={formValues.pan}
          errors={errors?.pan?.message}
          label="PAN Number (Optional)"
          register={{
            ...register("pan", {
              pattern: {
                value: REGEX.PAN_NUMBER,
                message: "Please enter a valid PAN.",
              },
            }),
          }}
        />
      </div>
      <div className="mt-4">
        <InputField
          label="Email ID"
          value={formValues.email}
          errors={errors?.email?.message}
          register={{
            ...register("email", {
              required: "Email is required.",
              pattern: {
                value: REGEX.EMAIL,
                message: "Please enter a valid email.",
              },
            }),
          }}
        />
      </div>
    </div>
  );
};

interface InputFieldProps {
  label: string;
  value?: string;
  errors?: any;
  placeholder?: string;
  register?: any;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  placeholder,
  value,
  errors,
  register,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="relative w-full flex flex-col">
      <input
        {...register}
        type="text"
        placeholder={placeholder}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(value !== "")} // Keeps label up if there's text
        className={`w-full px-4 pt-6 pb-2 text-lg border border-[#d7d7d7] rounded-[10px] bg-[#fff] 
              focus:outline-none focus:ring-2 focus:ring-[#e6d58d] focus:border-transparent
              peer`}
      />
      <label
        className={`absolute left-4 text-gray-400 transition-all 
              ${isFocused || value ? "top-2 text-[11px]" : "top-4 text-[18px]"}`}
      >
        {label}
      </label>
      {errors && (
        <div className="text-error text-sm font-normal mt-1">{errors}</div>
      )}
    </div>
  );
};

export default RentReceiptPersonalDetails;
